<template>
  <!-- The third party first, then its contracts (US 9369 + 9371). Shown on the third-party page and on its contracts. -->
  <div>
  <V2ParentSwitcher v-if="row && row.parent"
                    :parent="row.parent"
                    :children="children"
                    :selected="selected"
                    :parent-kind="$t('parent_switcher.vendor.kind')"
                    :parent-sub="$t('parent_switcher.vendor.sub')"
                    parent-icon="building"
                    child-icon="file-alt"
                    :child-label="$t('parent_switcher.vendor.children')"
                    :can-add="canAdd"
                    :add-label="$t('parent_switcher.vendor.add')"
                    :add-first-label="$t('parent_switcher.vendor.add_first')"
                    qid="vendor-switcher"
                    @select="open"
                    @add="$emit('add')"></V2ParentSwitcher>
  <!-- A shared contract: decide which third party it is with (US 9369 + 9371) -->
  <SharedLinkPanel ref="shared" kind="contract" @decided="decided"></SharedLinkPanel>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import V2ParentSwitcher from '@/components/V2ParentSwitcher.vue';
  import SharedLinkPanel from '@/components/SharedLinkPanel.vue';

  export default {
    name: 'VendorSwitcher',
    components: { V2ParentSwitcher, SharedLinkPanel },
    props: {
      // The page it's on: a third party, or one of its contracts
      vendor: { type: String, default: '' },
      contract: { type: String, default: '' },
      // On the merged third-party page the page decides what's picked: 'parent' or a contract id (US 9369 + 9371)
      controlled: { type: Boolean, default: false },
      picked: { type: [String, Number], default: 'parent' },
      canAdd: { type: Boolean, default: false }
    },
    data() {
      return {
        row: null
      };
    },
    computed: {
      getClient() {
        return this.$store.state.client;
      },
      selected() {
        if (this.controlled) {
          return this.picked;
        }
        return this.row && this.row.selected ? this.row.selected : 'parent';
      },
      children() {
        return (this.row ? this.row.children : []).map(child => Object.assign({}, child, {
          sub: this.sub(child),
          warnText: child.countries_without_basis
            ? this.$tc('parent_switcher.contract.without_basis', child.countries_without_basis, { count: child.countries_without_basis })
            : ''
        }));
      }
    },
    watch: {
      vendor() { this.load(); },
      contract() { this.load(); }
    },
    created() {
      this.load();
    },
    methods: {
      sub(child) {
        if (child.ended) {
          return this.$t('parent_switcher.contract.ended');
        }
        if (child.countries_without_basis) {
          return this.$tc('parent_switcher.contract.without_basis', child.countries_without_basis, { count: child.countries_without_basis });
        }
        return child.systems.length ? child.systems.slice(0, 2).join(', ') : this.$t('parent_switcher.contract.no_systems');
      },
      load() {
        if (!this.vendor && !this.contract) {
          return;
        }
        let url = this.contract ? 'third-parties/' + this.contract + '/switcher' : 'vendors/' + this.vendor + '/switcher';
        let self = this;
        piincHttp.get(url, { params: { client: this.getClient ? this.getClient.slug : undefined } }).then(function(response) {
          self.row = response.data;
          self.$emit('loaded', response.data);
        }, function() {
          self.row = null;
          self.$emit('loaded', null);
        });
      },
      reload() {
        this.load();
      },
      // Kept with its third party: it leaves this row. Moved here: it is now one of this third party's contracts.
      decided(event) {
        this.load();
        this.$emit('changed', event);
      },
      open(child) {
        if (child !== 'parent' && child.shared) {
          this.$refs.shared.show(child, { name: child.lives_in }, this.row.parent);
          return;
        }
        if (this.controlled) {
          this.$emit('select', child);
          return;
        }
        if (child === 'parent') {
          if (this.contract) {
            this.$router.push({ name: 'contracts.third_parties.view', params: { slug: this.row.parent.slug } });
          }
          return;
        }
        if (child.id !== this.selected) {
          this.$router.push({ name: 'contracts.view', params: { slug: child.slug } });
        }
      }
    }
  };
</script>
